import { render } from "./SectionComponent.vue?vue&type=template&id=7e08c045"
import script from "./SectionComponent.vue?vue&type=script&lang=js"
export * from "./SectionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__